<template>
  <el-dialog title="急救转运前评估" :append-to-body="true" :visible.sync="showTag" width="80%">
    <h3>1、绝对禁忌（任一一项为“是”则不能转运）</h3>
    <p>1）天气不具备，两处起降场地不具备直升机飞行条件</p>
    <p>2）危险天气和强颠簸天气</p>
    <h3>2、相对禁忌症（病人有以下情况，原则上不转运，如特殊情况，必须由双方医院科室主任评估后决定）</h3>
    <p>1）病人可能因空中气压变化导致病情加重，如意识水平降低、烦躁、气道梗阻、呼吸窘迫、休克的伤员</p>
    <p>2）可能存在空中的不确定风险</p>
    <h3>3、特殊病人注意事项</h3>
    <p>1）装有起搏、除颤设备应配备绝缘板进行屏隔</p>
    <p>2）注意尽量避免使用塑料输液袋，并及时调整输液速度</p>
    <p>3）对于腹胀、胃肠道疾病、胃肠贯通伤的患者要及时减压，气胸患者的病情在气压波动时可能会加重，应注意胸腔闭式引流及脑室引流的液面高度；</p>
    <p>4）对于体外循环装置而言，抗凝药物的使用必不可少，因而应备用足够数量的抗凝药物及测试凝血功能的检验设备。</p>

    <div class="flex jcc mt30">
      <el-button :disabled="disabled" @click="hide" type="primary">{{ time ? time + "S " : "" }}我已阅读并知晓以上内容</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "notice-dialog",
  data() {
    return {
      time: 10,
      showTag: false,
      disabled: true
    }
  },
  beforeDestroy() {
    this.clean();
  },
  methods: {
    show() {
      this.showTag = true;
      this.$nextTick(() => {
        this.djs()
      })
    },
    hide() {
      this.showTag = false
    },
    clean() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    djs() {
      this.clean();
      if (this.time === 0) {
        this.disabled = false;
      } else {
        this.timer = setTimeout(() => {
          if (this.time > 0) {
            this.time--;
            this.djs();
          }
        }, 1000)
      }
    }
  },
}
</script>

<style scoped lang="scss">
h3 {
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
}

p {
  font-size: 14px;
  padding: 0 15px;
  line-height: 200%;
}
</style>